export default {
  "Update case success": "El caso se ha actualizado correctamente",
  ru: "RU",
  en: "EN",
  languages: {
    ru: "Ruso",
    en: "Inglés",
    ar: "Árabe",
    es: "Español",
    fa: "Persa",
    kz: "Kazajo",
    pt: "Portugués",
    fr: "Francés",
  },
  CoursesTitle: "Cursos | " + process.env.VUE_APP_INSTALL_NAME + "",
  Module_AI: {
    title: "Inteligencia Artificial",
    desc: "Análisis de imágenes médicas mediante servicios de IA",
  },
  Module_edu: {
    title: "Educación",
    desc: "Simuladores visuales, cursos y materiales útiles para médicos",
  },
  Module_community: {
    title: "Comunidad",
    desc: "Intercambio de conocimientos entre médicos, discusión de casos clínicos",
  },
  Profile: "Perfil",
  Subscription: "Suscripción",
  "Go to site": "Ir al sitio",
  "Access after pay": "Lección aún no disponible",
  Exit: "Salir",
  MY: "MI CUENTA",
  Home: "Inicio",
  "Mobile banner text : demo":
    "Crea una cuenta y obtén acceso completo a los servicios de IA y simuladores",
  Platform: "PLATAFORMA PARA MÉDICOS",
  "Platform info":
    "Asistentes de IA, simuladores visuales, cursos y materiales útiles para médicos",
  "Download app": "Descargar la aplicación",
  "Home title":
    "Plataforma para médicos | " + process.env.VUE_APP_INSTALL_NAME + "",
  AI: "IA",
  edu: "Educación",
  community: "Comunidad",
  "Your courses": "Tus cursos",
  "Recomended courses": "Cursos recomendados",
  Courses: "Cursos",
  Calculator: "Calculadora",
  Plug: "Conectar",
  "Go to": "Ir a",
  Case: "Caso",
  Cases: "Casos",
  "Case success": "Completado",
  "Case unsuccess": "No completado",
  Modality: "Modalidad",
  "Page title tail": " | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Cant find service?": "¿No encuentras el servicio necesario?",
  "Text us": "Escríbenos",
  "I need AI for...": "Necesito un servicio de IA para...",
  "Thx for reply": "¡Gracias por tu sugerencia!",
  Send: "Enviar",
  Sent: "Enviado",
  "Cannot loading reply -- adblock":
    "No se pudo enviar. Por favor desactiva extensiones del navegador como VPN o bloqueadores de anuncios",
  Favorites: "Favoritos",
  "Cases about 1": "Agrega tu caso",
  "Cases about 2":
    "Discute casos interesantes, haz preguntas, ¡comparte tu experiencia! Agrega un caso, todos los estudios",
  "Cases about 3": "serán anonimizados",
  "Add case": "Agregar caso",
  All: "Todos",
  "I upload": "Subido",
  drafts: "Borradores",
  draft: "Borrador",
  "Case v2": "Caso",
  "Open study": "Abrir estudio",
  Comments: "Comentarios",
  "Comment placeholder": "Escribir comentario...",
  "Favorites about 1": "Aún no hay nada aquí, haz clic en el ícono",
  "Favorites about 2": "de un caso interesante para añadirlo a favoritos",
  "Comment screen info 1": "Para adjuntar una captura de pantalla, ",
  "Comment screen info 2": "abre el estudio en el visor",
  Download: "Descargar",
  "Record Date": "Fecha de la clase",
  "Request a course": "Solicitar curso",
  "Request a course doned": "Has solicitado el curso",
  "Forgot password?": "¿Olvidaste tu contraseña?",
  "Reset password": "Recuperar contraseña",
  "Reset password v2": "Restablecer contraseña",
  "Reset password about":
    "Indica el correo electrónico que usaste al registrarte. Te enviaremos instrucciones para recuperar tu contraseña",
  "Reset password about after":
    "Se ha enviado un enlace de recuperación a tu correo electrónico",
  "Back to prev page": "Volver atrás",
  Email: "Correo electrónico",
  "Not valid email": "Formato de correo inválido",
  EmailAlreadyRegistered: "El correo ya está registrado",
  NotActivatedAccount:
    "El usuario existe, pero su cuenta aún no ha sido activada.",
  "Not found email": "Correo electrónico no registrado",
  "Back to login": "Volver al inicio de sesión",
  "Email not come?": "¿No recibiste el correo?",
  "Write to support": "Escribir al soporte",
  "Create new password": "Crea una nueva contraseña",
  "Password confirm": "Confirmar contraseña",
  "Min 8": "Mínimo 8 caracteres",
  "Two inputs don't match!": "Las contraseñas no coinciden",
  "Update password": "Actualizar contraseña",
  "Password updated": "Contraseña actualizada",
  "Invalid password token": "Enlace no válido, intenta de nuevo",
  "Unknown user": "Usuario desconocido",
  "Attach image": "Adjuntar imagen",
  Remove: "Eliminar",
  Complain: "Reportar",
  "Complain sent": "Tu reporte ha sido enviado exitosamente",
  owner: "Autor del caso",
  assistant: "Moderador",
  "Answers 1": "respuesta",
  "Answers 2": "respuestas",
  "Answers 3": "respuestas",
  "Add answer": "Responder",
  "Collapse answers": "Colapsar",
  "Image only": "<Imagen>",
  "Cannot upload from mobile":
    "Puedes cargar estudios en formato DICOM desde una computadora",
  "Password rule":
    "Introduce al menos 8 caracteres, una letra latina y un número",
  ReferenceCursors: "C - cursor 3D",
  "bad browser for mpr":
    "MPR puede no estar disponible. Te recomendamos usar la última versión de Google Chrome",
  "Service in process": "Carga temporalmente no disponible",
  "Service in process about":
    "Pero puedes explorar la funcionalidad del servicio en estudios de demostración. Te avisaremos cuando puedas procesar tus propios estudios.",
  "Edit case": "Editar caso",
  Title: "Título",
  "Access count": "Disponible",
  "Access count about":
    "Si eliges 'Disponible para todos', la publicación será visible para todos. Con acceso por enlace, solo será accesible a través del botón 'Compartir'.",
  "To All": "Para todos",
  "To Link": "Por enlace",
  Publish: "Publicar",
  "Publish about":
    "Si publicas anónimamente, tu nombre y empresa no serán visibles para otros usuarios.",
  How: "Cómo",
  "As Anon": "Anónimo",
  "Case accept": "No publico ningún dato personal del paciente.",
  "User Policy": "Política de privacidad",
  "Remove case": "Eliminar caso",
  "Save draft": "Guardar borrador",
  "Remove case success": "Caso eliminado exitosamente",
  "Remove case error": "No se pudo eliminar el caso. Intenta más tarde",
  "Update case error": "No se pudo actualizar el caso. Intenta más tarde",
  Edit: "Editar",
  "Cases v2": "Casos",
  sec: " seg",
  "Confirm accept": "Confirma tu consentimiento",
  "Remove case?": "¿Eliminar estudio?",
  "Upload AI": "Sube un estudio en formato DICOM",
  "Upload edu": "Sube un caso en formato DICOM, JPEG o PNG",
  "Upload community": "Sube un caso en formato DICOM, JPEG o PNG",
  "As anon": "Anónimamente",
  status: {
    free: "Gratis",
    subscription: "Por suscripción",
    draft: "Borrador",
    archived: "Archivado",
    completed: "Completado",
  },
  courseType: {
    course: "Curso",
    simulator: "Simulador",
    webinar: "Seminario web",
  },
  noAcceptResult: "Describe con qué no estás de acuerdo",
  Meta: {
    tail: "%s | " + process.env.VUE_APP_INSTALL_NAME + "",
    tail2: " | " + process.env.VUE_APP_INSTALL_NAME + "",
    default: {
      title: "Plataforma para médicos",
      desc: process.env.VUE_APP_INSTALL_DESC,
    },
    "community-cases": {
      title: "Comunidad médica",
      desc: "Comunidad médica profesional en línea — ¡discusión de casos interesantes, preguntas e intercambio de experiencia!",
    },
    home: {
      title: "Plataforma para médicos",
      desc: "Plataforma médica en línea: asistentes de IA, simuladores visuales, cursos y materiales útiles para médicos",
    },
    "ai-services": {
      title: "Servicios de IA",
      desc: "Servicios de inteligencia artificial para diagnóstico médico",
    },
    "edu-services": {
      title: "Plataforma educativa para médicos",
      desc: "Lista de cursos y base de conocimiento para médicos especialistas en diagnóstico.",
    },
  },
  "Video is unavailable": "El video no está disponible",
  Licence:
    '© 2026 Sociedad Limitada "Third Opinion Platform", CNPJ 7714420229, OGRN 5177746328106, todos los derechos reservados. 121205, Moscú, Territorio del Centro de Innovación Skolkovo, calle Nobel, 7, 2º piso, cuarto 37, local de trabajo 2.',
  "Policy v2": "Política de tratamiento y protección de datos personales",
  "Site company": "Sitio de la empresa",
  homepage: {
    connect: "Conectar por ",
    cost: " / mes",
    goToAI: "Procesar estudios",
    notAuthSub__off: {
      title: "Desbloquea todo el potencial del asistente de IA",
      desc: "Accede al asistente de IA para automatizar mediciones y redactar informes",
    },
    notAuthSub__on: {
      title: "Servicios de IA para análisis de imágenes médicas",
      desc: "Automatiza las mediciones y genera un informe del estudio. Procesa 3 estudios gratis, luego — más por <PRICE>",
    },
    baseSub: {
      title: "Evita tareas rutinarias con IA",
      desc: "El asistente de IA automatiza mediciones y genera informes con un clic",
    },
    notBaseSub: {
      title: "Sube una imagen con un clic",
      desc: "Utiliza el asistente de IA para automatizar mediciones y generar informes",
    },
  },
  "Start type": "Empieza a escribir...",
  buy: "Comprar",
  more_details: "Leer más",
};
